import { Enturmacao } from '../services/mobile-frequencia.service';

/**
 * Extrai o nome do aluno de forma robusta (nome social tem prioridade).
 */
export function getNomeAluno(aluno: Enturmacao): string {
  return (
    aluno?.matricula?.nomeFantasia ||
    aluno?.matricula?.nomeSocial ||
    aluno?.nomeSocial ||
    aluno?.matricula?.nome ||
    aluno?.matricula?.aluno?.nome ||
    aluno?.matricula?.aluno?.pessoa?.nome ||
    aluno?.aluno?.nome ||
    aluno?.pessoa?.nome ||
    aluno?.nome ||
    'Nome não disponível'
  );
}

/**
 * Classe CSS do botão P/F/D/? do card de aluno no modo "frequência por dia",
 * baseada no registro histórico do dia selecionado (presente/falta/dispensado/sem registro).
 */
export function getButtonClassDia(aluno: Enturmacao, aulaRealizada: boolean): string {
  // desabilitado = não enturmado no dia
  if (aluno.desabilitado) {
    return 'bg-gray-300 cursor-not-allowed';
  }

  // Aula não realizada: grid volta ao estado "interrogação" mesmo com registros de falta/dispensa no backend.
  if (!aulaRealizada) {
    return 'bg-gray-400 text-white hover:bg-gray-500 cursor-not-allowed';
  }

  if (aluno.dispensado) {
    return 'bg-yellow-500 text-white hover:bg-yellow-600';
  }

  if (aluno.falta) {
    return 'bg-red-500 text-white hover:bg-red-600';
  }

  if (aluno.presente || aluno.presencaRemota) {
    return 'bg-green-500 text-white hover:bg-green-600';
  }

  if (!aluno.frequenciaId) {
    return 'bg-gray-400 text-white hover:bg-gray-500';
  }

  return 'bg-gray-300 cursor-not-allowed';
}

/**
 * Label (P/F/D/?) do botão do card de aluno no modo "frequência por dia",
 * baseado no mesmo registro histórico usado em `getButtonClassDia`.
 */
export function getStatusLabelDia(aluno: Enturmacao, aulaRealizada: boolean): string {
  if (!aulaRealizada) {
    return '?';
  }

  if (aluno.dispensado) {
    return 'D';
  }

  if (aluno.falta) {
    return 'F';
  }

  if (aluno.presente || aluno.presencaRemota) {
    return 'P';
  }

  return '?';
}
